import { useEffect } from 'react';
import { useMessage } from '../../contexts/MessageContext';
import { dismissThirdLevelAlert } from '../../services/dashboardService';

function parseBodyString(bodyStr) {
  if (!bodyStr) return null;
  const trimmed = bodyStr.trim().replace(/^\{|\}$/g, '');
  const parts = trimmed.split(',');
  const result = {};
  parts.forEach(part => {
    const [key, ...rest] = part.split('=');
    if (!key || rest.length === 0) return;
    const value = rest.join('=').trim();
    result[key.trim()] = value.trim();
  });
  return result;
}

export default function Alarm() {
  const { alarmMessage, closeMessage, setForceOpenModalType } = useMessage();
  const parsedData = alarmMessage?.data;

  // ✅ 알람이 새로 들어오면 여성 TTS 음성으로 읽기
  useEffect(() => {
    if (alarmMessage && parsedData?.type === '2차 응급') {
      const messageText = `${parsedData.name || '사용자'} 님 에게 ${parsedData.type} 알림이 발생했습니다.`;

      // 음성 합성 객체 생성
      const utterance = new SpeechSynthesisUtterance(messageText);
      utterance.lang = 'ko-KR';
      utterance.rate = 1.0;
      utterance.pitch = 1.1;

      // 가능한 음성 중 여성 음성 선택
      const voices = window.speechSynthesis.getVoices();
      const femaleVoice =
        voices.find(v => v.lang === 'ko-KR' && v.name.includes('Female')) ||
        voices.find(v => v.lang === 'ko-KR') ||
        voices[0];
      if (femaleVoice) utterance.voice = femaleVoice;

      // 음성 재생
      speechSynthesis.cancel(); // 기존 음성 중단
      speechSynthesis.speak(utterance);
    }
  }, [alarmMessage, parsedData]);

  if (!alarmMessage || !parsedData) return null;

  const handleClose = async () => {
    const { type, alert_id } = parsedData;
    if (type?.trim() === '2차 응급' && alert_id) {
      const token = localStorage.getItem('token');
      // await dismissThirdLevelAlert(alert_id, token);
    }
    closeMessage();
  };

  const handleRecordClick = () => {
    // ✅ 모달 강제 열기
    setForceOpenModalType('occur');
    closeMessage();
  };

  return (
    <div className={`front_alarm ${alarmMessage ? 'active' : ''}`}>
      <div className="alarmForm">
        <h3>{alarmMessage.title || '-'}</h3>
        <div className="alarmbox">
          <p>
            <span>{parsedData.address || '-'}</span> {parsedData.name || '-'} 님
          </p>
          <p className="textright">
            <span>{parsedData.pec || '-'}</span> 만 {parsedData.age || '-'} 세
          </p>
        </div>
        <div className="btn-group">
          {/* 필요 시 아래 버튼 주석 해제 */}
          {/* {parsedData.type?.trim() === '2차 응급' && (
            <>
              <button
                className="btncolor05"
                onClick={() => {
                  if (window.Android && window.Android.openDialer) {
                    window.Android.openDialer('119');
                  } else {
                    window.location.href = 'tel:119';
                  }
                }}
              >
                119 신고
              </button>
              <button className="btncolor02" onClick={handleRecordClick}>
                기록작성
              </button>
            </>
          )} */}
          <button className="btncolor01" onClick={handleClose}>
            닫기
          </button>
        </div>
      </div>
    </div>
  );
}
